// extracted by mini-css-extract-plugin
export default {"appsToSelectContainer":"RJ2K8lCKREbuxDJGKERruQ==","appInfoTime":"hIysgOjMy8QSTitUAhKAKA==","logoContainer":"hFrjOchkYSx+UQdoOEzqFw=="};